import { Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [done, setDone] = useState(false);
  const [animateOnLoad, setAnimateOnLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimateOnLoad(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth',
      });
      setMobileOpen(false);
    }
  };

  useEffect(() => {
    setDone(true);
  }, []);

  return (
    <div style={{ minHeight: isMobile ? '45vh' : '100vh' }}>
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          maxHeight: '100vh',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '60vh',
            zIndex: 100,
            background: 'linear-gradient(180deg, #FFFFFF, transparent)',
          }}
        />
        <div
          className="page-alignement"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            textAlign: isMobile ? 'center' : '',
            marginTop: isMobile ? '14vh' : '18vh',
            height: isMobile ? '55vh' : '45vh',
            maxWidth: '1000px',
            zIndex: 1000,
          }}
        >
          <h1
            style={{
              color: 'black',
              '@media (max-width: 768px)': { color: 'white' },
              zIndex: 10000,
            }}
            className="title text-mobile"
          >
            {t('dedicatedTransport')}{' '}
            <span className="gradient-text">{t('neutraEmission')}</span>{' '}
            {t('desservedArea')}
          </h1>
          <div
            style={{
              marginTop: isMobile ? '45px' : '20px',
              zIndex: 10000,
              display: isMobile ? 'none' : 'flex',
              opacity: isMobile ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out',
              height: isMobile ? '0px' : '',
            }}
            className="d-flex"
          >
            <div className="row">
              <div className="col-3">
                <img className="icons" src="./img/delivery.svg" height={38} />
              </div>
              <div
                style={{ marginTop: '4px', marginLeft: '5px' }}
                className="col-8 text-mobile"
              >
                <h3 className="oxanium text">{t('delivery')}</h3>
                <p
                  style={{ marginTop: '-12px' }}
                  className="oxanium text-small"
                >
                  {t('deliverySub')}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-3">
                <img className="icons" src="./img/electric.svg" height={35} />
              </div>
              <div
                style={{ marginTop: '4px', marginLeft: '5px' }}
                className="col-8 text-mobile"
              >
                <h3 className="oxanium text">{t('electric')}</h3>
                <p
                  style={{ marginTop: '-12px' }}
                  className="oxanium text-small"
                >
                  {t('electricSub')}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-3">
                <img className="icons" src="./img/calendar.svg" height={35} />
              </div>
              <div
                style={{ marginTop: '4px', marginLeft: '5px' }}
                className="col-8 text-mobile"
              >
                <h3 className="oxanium text">{t('quickCalendar')}</h3>
                <p
                  style={{ marginTop: '-12px' }}
                  className="oxanium text-small"
                >
                  {t('quickCalendarSub')}
                </p>
              </div>
            </div>
          </div>
          <Button
            onClick={() => handleScroll('section2')}
            className={`mt-4 button-black ${
              animateOnLoad ? 'animate-on-load' : ''
            }`}
            variant="contained"
            color="primary"
            style={{
              padding: '8px 12px',
              backgroundColor: '#000000',
              color: '#FFFFFF',
              borderRadius: '30px',
            }}
          >
            {t('getQuote')}
          </Button>
        </div>
        {/* Background Image */}
        <div
          style={{ position: 'relative', width: '100%', maxHeight: '100vh' }}
        >
          {/* <div className="wind-layer wind-layer-1"></div>
          <div className="wind-layer wind-layer-2"></div>
          <div className="wind-layer wind-layer-3"></div>
          <div className="wind-layer wind-layer-4"></div> */}
          <img
            src={done ? './img/header-tsg.jpeg' : './img/header-tsg.jpg'}
            width="100%"
            className={done ? 'smooth-img' : ''}
            style={{ objectFit: 'cover', maxHeight: '100vh' }}
          />
          <img
            src={'./img/header.jpg'}
            width="100%"
            className={''}
            style={{
              position: 'absolute',
              zIndex: -1,
              top: 0,
              objectFit: 'cover',
              maxHeight: '100vh',
            }}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '45vh',
            background: 'linear-gradient(0deg, #000, transparent)',
          }}
        />
      </div>
    </div>
  );
};

export default Header;
